import api from "@/api";
import featured from "@/api";
import Moralis from "moralis";
import Web3 from "web3";
import Web3Modal from "web3modal";
import state from "../state";
import { EvmChain } from "moralis/common-evm-utils";
import shuffle from "lodash/shuffle";
import ones from "../../assets/ones.png";

export default {
  OpenMemeModal(context, memeId) {
    context.commit("SetMemeModal", !state.openMemeModal);
    context.commit("SelectMeme", state.memePreviews[memeId]);
  },

  ChangeActiveLink(context, activeLink) {
    context.commit("SetActiveLink", activeLink);
  },

  ChangeSearchMessage(context, searchMessage) {
    context.commit("SetSearchMessage", searchMessage);
  },

  SwitchTheme(context, theme) {
    let foreground;
    let background;
    let subtitle;
    let divider;
    let hover;

    if (theme === "light") {
      foreground = "#000000";
      background = "#ffffff";
      subtitle = "#8b98a5";
      divider = "#e3e5e8";
      hover = "#e9ebee";
    } else {
      foreground = "#FFFFFF";
      background = "#17191C";
      subtitle = "#ADB6C0";
      divider = "#e3e5e8";
      hover = "#373a3c";
    }
    document.documentElement.style.setProperty(
      "--color-foreground",
      foreground
    );
    document.documentElement.style.setProperty(
      "--color-background",
      background
    );
    document.documentElement.style.setProperty("--color-subtitle", subtitle);
    document.documentElement.style.setProperty("--color-divider", divider);
    document.documentElement.style.setProperty("--color-hover", hover);

    context.commit("SetTheme", theme);
  },

  async ConnectWallet(context) {
    const web3modal = new Web3Modal({
      network: process.env.VUE_APP_CONTRACT_NETWORK,
      cacheProvider: false,
      providerOptions: state.providerOptions,
    });

    const provider = await web3modal.connect();
    context.commit("SetProvider", provider);

    context.commit("SetWeb3", new Web3(state.provider));
    const address = (await state.web3.eth.getAccounts())[0] || null;
    context.commit("SetAccount", address);

    context.dispatch("FetchUserNFTs");
  },

  DisconnectWallet(context) {
    context.commit("SetProvider", null);
    context.commit("SetWeb3", null);
    context.commit("SetAccount", null);
    context.commit("SetWalletNFTs", null);
  },

  async GetMemePreviews(context, id) {

    if ([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 63, 2093, 4920, 5403, 6666, 6969, 9950].includes(id)) {
      const response = await api.get(`/getallmemes/9343`);
      const updated = response.data.map((item) => ({
        ...item,
        image: ones,
        thumbnail: ones,
        blurred_thumbnail: ones,
        author: "@" + item.author,
      }));
      context.commit("SetMemePreviews", updated);
      return;
    }

    const response = await api.get(`/getallmemes/${id}`);
    const updated = response.data.map((item) => ({
      ...item,
      author: "@" + item.author,
    }));

    context.commit("SetMemePreviews", updated);
  },

  async GetFeaturedMemes(context, id){
    if ([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 63, 2093, 4920, 5403, 6666, 6969, 9950].includes(id)) {
      const response = await featured.get(`/featured/9343`);
      const updated = response.data.map((item) => ({
        ...item,
        image: ones,
        thumbnail: ones,
        blurred_thumbnail: ones,
        author: "@" + item.author,
      }));
      context.commit("SetFeaturedMemes", updated);
      return;
    }
    const response = await featured.get(`/featured/${id}`);
    const updated = response.data.map((item) => ({
      ...item,
      author: "@" + item.author,
    }))
    context.commit("SetFeaturedMemes", updated);
  },
  async ShuffleMemes(context) {
    const memes = state.memePreviews;
    const shuffled = shuffle(memes);

    context.commit("SetMemePreviews", shuffled);
  },

  async FetchUserNFTs(context) {
    const sender = state.account;
    if (!sender) throw new Error("Sender address not found");

    const chain = EvmChain.ETHEREUM;

    let cursor = null;
    let nfts = [];
    do {
      let response = await Moralis.EvmApi.nft.getWalletNFTs({
        address: sender,
        chain: chain,
        cursor: cursor,
      });
      for (const nft of response.result) {
        nfts.push({
          tokenId: nft.tokenId,
          tokenName: nft.name,
          tokenAddress: nft.tokenAddress,
        });
      }
      cursor = response.jsonResponse.cursor;
    } while (cursor != "" && cursor != null);

    context.commit("SetWalletNFTs", nfts);
  },
};
